import { ValidationRule } from 'react-hook-form';

export const passwordPattern: ValidationRule<RegExp> = {
  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[a-zA-Z\d\W_]{8,}$/,
  message:
    'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character',
};
